import React from "react";
import { Box, Button, Card, IconButton, Stack, Typography } from "@mui/material";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import StepUpSpinner from "../../../../Components/Loader/StepUpSpinner";

type Props = {
  refreshedAt: Date | null;
  loading: boolean;
  exporting: null | "csv" | "pdf";
  onRefresh: () => void;
  onCsv: () => void;
  onPdf: () => void;
};

export default function PremiumHeader({
  refreshedAt, loading, exporting, onRefresh, onCsv, onPdf,
}: Props) {
  return (
    <Card variant="outlined" sx={{ p: 2, mb: 2, borderRadius: 2 }}>
      <Stack direction={{ xs: "column", md: "row" }} alignItems={{ md: "center" }} spacing={2}>
        <Stack direction="row" spacing={2} flex={1} alignItems="center">
          <Box sx={{
            width: 48, height: 48, borderRadius: "50%",
            background: "#eff6ff", color: "#1b3a6b",
            display: "flex", alignItems: "center", justifyContent: "center",
          }}>
            <GroupsOutlinedIcon />
          </Box>
          <Box>
            <Typography variant="h6" fontWeight={700} color="#1b3a6b">
              Student Class Assignments
            </Typography>
            <Typography variant="body2" color="text.secondary">
              View students and their assigned classes, staff, subjects, schedules, and locations.
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {refreshedAt ? `Last refreshed ${refreshedAt.toLocaleTimeString()}` : "—"}
            </Typography>
          </Box>
        </Stack>

        <Stack direction="row" spacing={1} flexWrap="wrap">
          <IconButton onClick={onRefresh} disabled={loading} title="Refresh" size="small"
            sx={{ border: "1px solid #e2e8f0" }}>
            <RefreshOutlinedIcon fontSize="small" />
          </IconButton>
          <Button variant="outlined" size="small"
            startIcon={exporting === "csv" ? <StepUpSpinner size="small" /> : <FileDownloadOutlinedIcon />}
            onClick={onCsv} disabled={loading || !!exporting}>
            {exporting === "csv" ? "Preparing CSV…" : "CSV"}
          </Button>
          <Button variant="outlined" size="small"
            startIcon={exporting === "pdf" ? <StepUpSpinner size="small" /> : <PictureAsPdfOutlinedIcon />}
            onClick={onPdf} disabled={loading || !!exporting}>
            {exporting === "pdf" ? "Preparing PDF…" : "PDF"}
          </Button>
          <Button variant="outlined" size="small"
            startIcon={<PrintOutlinedIcon />}
            onClick={() => window.print()} disabled={loading}>
            Print
          </Button>
        </Stack>
      </Stack>
    </Card>
  );
}
